import React, { useState } from 'react';
import { useUser } from './UserProvider';
import useAdminVerification from '../hooks/useAdminVerification';
import Auth from './Auth';
import './UserMenu.css';

const UserMenu = () => {
    const { user, logout, isAuthenticated } = useUser();
    const { isAdminVerified } = useAdminVerification();
    const [showAuth, setShowAuth] = useState(false);
    const [showUserMenu, setShowUserMenu] = useState(false);

    const handleAuthSuccess = () => {
        // UserProvider의 login이 이미 상태를 업데이트하므로 모달만 닫으면 됨
        setShowAuth(false);
    };

    const handleLogout = async () => {
        await logout();
        setShowUserMenu(false);
    };

    const toggleUserMenu = () => {
        setShowUserMenu(!showUserMenu);
    };

    const closeUserMenu = () => {
        setShowUserMenu(false);
    };

    const openAccountSettings = () => {
        window.location.href = '/pages/accountsettings';
        setShowUserMenu(false);
    };

    const openAdminDashboard = () => {
        window.location.href = '/admin';
        setShowUserMenu(false);
    };

    if (!isAuthenticated()) {
        return (
            <>
                <button 
                    className="login-button"
                    onClick={() => setShowAuth(true)}
                >
                    로그인
                </button>
                
                {showAuth && (
                    <Auth 
                        onAuthSuccess={handleAuthSuccess}
                        onClose={() => setShowAuth(false)}
                    />
                )}
            </>
        );
    }

    return (
        <div className="user-menu-container">
            <button 
                className="user-button"
                onClick={toggleUserMenu}
            >
                <span className="user-icon">👤</span>
                <span className="username">{user.username}</span>
                <span className="dropdown-arrow">▼</span>
            </button>

            {showUserMenu && (
                <>
                    <div className="user-menu-overlay" onClick={closeUserMenu}></div>
                    <div className="user-menu-dropdown">
                        <div className="user-menu-header">
                            <div className="user-info">
                                <span className="user-icon-large">👤</span>
                                <div className="user-details">
                                    <div className="user-name">{user.username}</div>
                                    <div className="user-email">{user.email}</div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="user-menu-divider"></div>
                        
                        <div className="user-menu-items">
                            {isAdminVerified && (
                                <button className="user-menu-item" onClick={openAdminDashboard}>
                                    <span className="menu-icon">🛠️</span>
                                    관리자 대시보드
                                </button>
                            )}
                            <button className="user-menu-item" onClick={openAccountSettings}>
                                <span className="menu-icon">⚙️</span>
                                계정 설정
                            </button>
                            <button className="user-menu-item" onClick={handleLogout}>
                                <span className="menu-icon">🚪</span>
                                로그아웃
                            </button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default UserMenu;
